import { createContext } from "react";
import { defaultConfirmationsWidthCallbackContextState } from "hooks/useConfirmationWithCallback";

const noop = () => null;

/**
 * @typedef {import("types/confirmationTypes").ConfirmationsWithCallbackProps} ConfirmationsWithCallbackProps
 */

/**
 * @typedef {import("types/stateTypes").UserData} UserData
 */

/**
 * @type {{
 *  confirmationWithCallback: ConfirmationsWithCallbackProps;
 *  openConfirmationWithCallback: React.Dispatch<React.SetStateAction<ConfirmationsWithCallbackProps>>;
 *  closeConfirmationWithCallback: () => void;
 *  warning: any;
 *  showWarning: (props: { title: any; content: any; buttonLabel?:string }) => void;
 *  hideWarning: () => void;
 *  defaultTenantAssignmentData: any;
 *  setDefaultTenantAssignmentData: (props: any) => void;
 * }}
 */
export const initialContextState = {
  confirmationWithCallback: defaultConfirmationsWidthCallbackContextState,
  openConfirmationWithCallback: noop,
  closeConfirmationWithCallback: noop,
  warning: {},
  showWarning: noop,
  hideWarning: noop,
  defaultTenantAssignmentData: {},
  setDefaultTenantAssignmentData: noop,
};

export const GlobalContext = createContext(initialContextState);
